module.exports = __webpack_public_path__ + "img/34.421815a2.jpg";